<template>
  <v-card
    style="width: 100% !important; height: 100% !important; overflow: hidden"
  >
    <v-toolbar dense flat style="background: transparent">
      <v-toolbar-title>{{
        module.name === null ? "" : module.title
      }}</v-toolbar-title>
    </v-toolbar>

    <v-card-text style="margin-bottom: 1rem">
      <h3 class="text-center display-2 pa-2" style="width: 100%; height: 100%">
        {{ getLabel }}
        <v-icon class="mb-2" large :color="getTrendColor">{{
          getTrendIcon
        }}</v-icon>
        <v-icon
          size="55"
          class="pb-2"
          v-if="metaHasKey(module.meta, MetaEnum.ICON)"
          >{{ getMeta(module.meta, MetaEnum.ICON).value }}</v-icon
        >
      </h3>
      <v-divider class="mb-4" />
      <h4 class="mt-4 text-center">{{ date }}</h4>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Meta from "@/_helpers/ModuleMeta";

export default {
  name: "ModuleSingle",

  mixins: [Meta],

  data() {
    return {
      date: "N/A",
      posTrend: null,
      tdata: 0.0,
      prevVal: null,
    };
  },

  props: ["module", "timerTick"],

  methods: {
    ...mapActions("tagData", { getData: "getTagDataWithMetrics" }),

    async loadData() {
      let d = await this.getData({
        metrics: {
          tag: this.module.tag.deveui,
          key: this.module.key,
          limit: 2,
        },
      });

      // Check if rounding is defined in module meta, default to 3 digits
      let digits = this.getMeta(
        this.module.meta,
        this.MetaEnum.DECIMAL_ROUNDING
      );

      // Make sure rounding is a valid number and reasonable
      digits = digits != null && digits.value <= 6 ? digits.value : 3;

      // Check if key has more than one value otherwise use the first one
      if (d[1] !== undefined) {
        this.prevVal = +parseFloat(d[0].value).toFixed(digits);
        this.tdata = +parseFloat(d[1].value).toFixed(digits);
        this.date = this.humanDate(d[1].createdAt);
      } else {
        this.tdata = +parseFloat(d[0].value).toFixed(digits);
        this.date = this.humanDate(d[0].createdAt);
      }
    },
  },

  computed: {
    ...mapState("tagData", ["tagData"]),

    MetaEnum() {
      return Meta.Enum;
    },

    getLabel() {
      // Check if the type is named value
      for (let i = 0; i < this.module.meta.length; i++) {
        if (parseFloat(this.module.meta[i].valueMatch) === this.tdata)
          return this.module.meta[i].value;
      }

      let prefix = this.getMeta(this.module.meta, Meta.Enum.PREFIX);
      let suffix = this.getMeta(this.module.meta, Meta.Enum.SUFIX);
      let str = [];
      if (prefix) str.push(prefix.value);
      str.push(this.tdata);
      if (suffix) str.push(suffix.value);

      return str.join(" ");
    },

    getTrendColor() {
      let vNow = +parseFloat(this.tdata);
      let vPrev = +parseFloat(this.prevVal);

      if (vNow > vPrev) return "green";
      else if (vNow < vPrev) return "red";
      else return "yellow";
    },

    getTrendIcon() {
      let vNow = +parseFloat(this.tdata);
      let vPrev = +parseFloat(this.prevVal);

      if (vNow > vPrev) return "mdi-trending-up";
      else if (vNow < vPrev) return "mdi-trending-down";
      else return "mdi-trending-neutral";
    },
  },

  async mounted() {
    this.loadData();
  },

  watch: {
    timerTick() {
      this.loadData();
    },
  },
};
</script>

<style scoped>
.date-bottom {
  bottom: 0;
  position: absolute;
}
</style>
